import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { FEATURE_FLAG_DEFAULT_VALUES } from "@src/appV2/FeatureFlags/constants";
import { useQuery } from "@tanstack/react-query";

import { type GeoLocation } from "../types";
import { getGeofenceStatus } from "../utils/getGeofenceStatus";

export interface UseIsInsideGeofenceParams {
  requestUniqueId: {
    workerId: string;
    shiftId: string;
  };
  action: "clock-in" | "clock-out" | "calculate-driving-distance" | "verify-charting";
  fallbackGeofenceDistanceInMiles?: number;
  fallbackGeofenceLocation?: GeoLocation;
}

const WORKPLACE_DEFAULT_GEOFENCE_DISTANCE_IN_MILES = 0.75;

export function useLazyIsInsideGeofence(params: UseIsInsideGeofenceParams) {
  const {
    requestUniqueId,
    action,
    fallbackGeofenceDistanceInMiles = WORKPLACE_DEFAULT_GEOFENCE_DISTANCE_IN_MILES,
    fallbackGeofenceLocation,
  } = params;

  const hyperTrackGeotagEvents = useCbhFlag(CbhFeatureFlag.HYPER_TRACK_GEOTAG_EVENTS, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.HYPER_TRACK_GEOTAG_EVENTS],
  });

  const isHyperTrackEnabled = useCbhFlag(CbhFeatureFlag.HYPERTRACK_CLOCK_IN_OUT, {
    defaultValue: false,
  });

  const query = useQuery({
    queryKey: ["isInsideOfGeofence", requestUniqueId, action],
    queryFn: async () => {
      return await getGeofenceStatus({
        requestUniqueId,
        action,
        hyperTrackGeotagEvents,
        fallbackGeofenceDistanceInMiles,
        fallbackGeofenceLocation,
        isHyperTrackEnabled,
      });
    },

    enabled: false,
  });

  return query.refetch;
}

export type { GetGeofenceStatusResult as UseIsInsideGeofenceResult } from "../utils/getGeofenceStatus";
